import React from 'react'
import { connect } from 'react-redux'
import "../../styles/manage-styles.scss"
import { setGlobalLoading } from 'redux/actions/actionCommon'
import { Table } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import Pagination from 'components/CommonComponents/Pagination/Pagination'

function ManageIntegrationTable(props) {
    const paginationLinks = [1, 2, 3, 4, 5]

    return (
        <section id="app-manage-integration" >
            <div className="manage-integration-content">
                <div className="app-card pad-25">
                    <div className="app-card-content border st-default-rounded-block mb-3">
                        <div className="st-listing-table ">
                            <Table responsive className="mb-0">
                                <thead>
                                    <tr>
                                        <th width="300">
                                            <p className="text-capitalize">
                                                Integration
                                            </p>
                                        </th>
                                        <th width="100">
                                            <p className="text-capitalize">
                                                status
                                            </p>
                                        </th>
                                        <th width="600">
                                            <p className="text-capitalize">
                                                company
                                            </p>
                                        </th>
                                        <th width="70">
                                            <p className="text-capitalize">
                                                Action
                                            </p>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td className="">
                                            <p className="">
                                                <FeatherIcon
                                                    icon="slash"
                                                    size="18"
                                                    className="icon me-2" />
                                                Google Analytics
                                            </p>
                                        </td>
                                        <td className="text-success st-fw-600">
                                            <p className="">
                                                Active
                                            </p>
                                        </td>
                                        <td className="">
                                            <p className="text-capitalize">
                                                NSO
                                            </p>
                                        </td>
                                        <td className="">
                                            <FeatherIcon
                                                icon="help-circle"
                                                size="18"
                                                className="icon text-warning" />
                                            <FeatherIcon
                                                icon="settings"
                                                size="16"
                                                className="icon text-dark ms-2" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            <p className="">
                                                <FeatherIcon
                                                    icon="slash"
                                                    size="18"
                                                    className="icon me-2" />
                                                Facebook
                                            </p>
                                        </td>
                                        <td className="text-danger st-fw-600">
                                            <p className="">
                                                Failed
                                            </p>
                                        </td>
                                        <td className="">
                                            <p className="text-capitalize">
                                                NSO
                                            </p>
                                        </td>
                                        <td className="">
                                            <FeatherIcon
                                                icon="help-circle"
                                                size="18"
                                                className="icon text-warning" />
                                            <FeatherIcon
                                                icon="settings"
                                                size="16"
                                                className="icon text-dark ms-2" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            <p className="">
                                                <FeatherIcon
                                                    icon="slash"
                                                    size="18"
                                                    className="icon me-2" />
                                                Google Ads
                                            </p>
                                        </td>
                                        <td className="text-success st-fw-600">
                                            <p className="">
                                                Active
                                            </p>
                                        </td>
                                        <td className="">
                                            <p className="text-capitalize">
                                                NSO
                                            </p>
                                        </td>
                                        <td className="">
                                            <FeatherIcon
                                                icon="help-circle"
                                                size="18"
                                                className="icon text-warning" />
                                            <FeatherIcon
                                                icon="settings"
                                                size="16"
                                                className="icon text-dark ms-2" />
                                        </td>
                                    </tr>

                                </tbody>
                            </Table>
                            <div className="pagination-container d-flex justify-content-center mt-3">
                                <Pagination
                                    // searchQuery={searchQuery}
                                    // routeName={"/my-sales/customers"}
                                    paginationLinks={paginationLinks}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(ManageIntegrationTable)